import { MESSAGE_TYPE, WIZARD_EVENT_KIND, INNER_EVENT_KIND } from './constants.js';

const createWizardEvent = (eventName, data) => ({
  type: MESSAGE_TYPE,
  kind: WIZARD_EVENT_KIND,
  eventName,
  data
});
const createFrameInnerEvent = (eventName, data) => ({
  type: MESSAGE_TYPE,
  kind: INNER_EVENT_KIND,
  eventName,
  data
});

export { createFrameInnerEvent, createWizardEvent };
